import { forwardRef, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { getBonusStatusNameTranslation } from '../../../../helpers';
import { BonusStage } from '@/api/common';
import { formatDateTime } from '@/helpers/dateTime';
import { useCommonStore } from '@/store';

import { ScBonusStatusLabel, ScTable, ScTr } from './styled';

const formatDate = formatDateTime('dd.MM.yyyy');

export interface BonusTableRow {
  createdAt: string;
  validUntil: string | null;
  title: string;
  sum: string | number | JSX.Element;
  stage: BonusStage;
  progress: JSX.Element;
}

export const BonusTable = forwardRef<HTMLDivElement, { rows: BonusTableRow[] }>(
  ({ rows }, ref) => {
    const { t, i18n } = useTranslation('bonuses');

    const isMobile = useCommonStore.use.isMobileDevice();

    const stageTranslate = useCallback(
      (stage: BonusStage) => {
        return getBonusStatusNameTranslation(t, i18n, stage);
      },
      [i18n, t]
    );

    return (
      <ScTable ref={ref}>
        <ScTr>
          <span className="th">{t('historyTable.issued')}</span>
          <span className="th">{t('historyTable.vaildTill')}</span>
          <span className="th">{t('historyTable.name')}</span>
          <span className="th">{t('historyTable.sum')}</span>
          {!isMobile && <span className="th">{t('historyTable.stage')}</span>}
          <span className="th">{t('historyTable.progress')}</span>
        </ScTr>
        <div className="body">
          {rows.map(
            ({ createdAt, validUntil, title, sum, stage, progress }, id) => (
              <ScTr key={id}>
                <span>
                  <span className="mobile-title">
                    {t('historyTable.issued')}
                  </span>
                  {formatDate(createdAt)}
                </span>
                <span>
                  <span className="mobile-title">
                    {t('historyTable.vaildTill')}
                  </span>
                  {validUntil ? formatDate(validUntil) : '-'}
                </span>
                <span>
                  <span className="mobile-title">{t('historyTable.name')}</span>
                  {title}
                </span>
                <span>
                  <span className="mobile-title">{t('historyTable.sum')}</span>
                  {sum}
                </span>
                <span className="stage">
                  <ScBonusStatusLabel status={stage}>
                    {stageTranslate(stage)}
                  </ScBonusStatusLabel>
                </span>
                <span>
                  <span className="mobile-title">
                    {t('historyTable.progress')}
                  </span>
                  {progress}
                </span>
              </ScTr>
            )
          )}
        </div>
      </ScTable>
    );
  }
);
